module.exports = __webpack_public_path__ + "img/DSC_2889-xl.794cfa6f.png";